<template>
  <div class="d-flex align-items-center" v-if="showAccount">
    <div
      class="dropdown d-none d-md-block"
      data-toggle="tooltip"
      title=""
      data-placement="top"
      data-original-title="Сменить ЛС"
    >
      <a
        class="btn-lv-white"
        href="#"
        role="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <span class="d-none d-md-inline">Сменить ЛС</span>
      </a>

      <ul class="dropdown-menu dropdown-menu-end mt-3">
        <li class="" v-for="(item, index) in auth.account_list" :key="index">
          <a class="dropdown-item" href="#" @click="onSubmitAccount(item.id)"
            >{{ item.account_num }} <br />
            <small>{{ item.address }}</small></a
          >
        </li>
        <li>
          <RouterLink :to="{ name: 'ConnectAccount' }" class="dropdown-item"
            >Подключить ЛС</RouterLink
          >
        </li>
      </ul>
    </div>
    <div
      class="dropdown d-block d-md-none"
      data-toggle="tooltip"
      title=""
      data-placement="top"
      data-original-title="Сменить ЛС"
    >
      <a
        class="btn-lv-white"
        href="#"
        role="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#39457C"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle cx="12" cy="8" r="4"></circle>
          <path d="M4 20c0-4 4-6 8-6s8 2 8 6"></path>
        </svg>
      </a>

      <ul class="dropdown-menu dropdown-menu-end mt-3">
        <li class="" v-for="(item, index) in auth.account_list" :key="index">
          <a class="dropdown-item" href="#" @click="onSubmitAccount(item.id)"
            >{{ item.account_num }} <br />
            <small>{{ item.address }}</small></a
          >
        </li>
        <li>
          <RouterLink :to="{ name: 'ConnectAccount' }" class="dropdown-item"
            >Подключить ЛС</RouterLink
          >
        </li>
      </ul>
    </div>
  </div>
  <div class="d-flex align-items-center" v-else>
    <RouterLink :to="{ name: 'ConnectAccount' }" class="btn-lv-white"
      >Подключить ЛС</RouterLink
    >
  </div>
</template>
<script setup>
import { useAuthStore } from "@/stores/user-auth";
import baseAPI from "@/stores/base-api";
import { useRouter } from "vue-router";
import { computed } from "vue";
import { RouterLink } from "vue-router";

const router = useRouter();
const auth = useAuthStore();

const showAccount = computed(() => {
  return auth.accountCount > 0;
});

async function onSubmitAccount(account_id) {
  await baseAPI()
    .post("/accounts/" + account_id + "/change-account")
    .then((response) => {
      router.push("/");
    })
    .catch((error) => {});
  await auth.getCurrentUser(true);

  return false;
}
</script>
<style>
.btn-lv-white {
  display: block;
  padding: 12px 24px;
  height: 48px;
  background: #ffffff;
  border-radius: 16px;
  font-size: 16px;
  line-height: 24px;
  color: #39457c;
  text-decoration: none;
}
.dropdown-menu-right {
  right: 0;
  left: auto;
}
@media (max-width: 768px) {
  .btn-lv-white {
    padding: 12px;
  }
}
</style>
